// extracted by mini-css-extract-plugin
export default {"identifiers":"Identifiers_identifiers__SIzS4"};